<template>
  <v-btn
    class="modal-button"
    height="32"
    variant="outlined"
    color="primary"
    rounded="lg"
    :disabled="disabled"
    @click="setModal({ field: 'settings', value: true })"
  >
    New {{ displayPageName }}
  </v-btn>

  <CreateModal
    :show="show.settings"
    :action-text="`Create ${displayPageName}`"
    :cancel-text="params.from ? 'Cancel' : ''"
    @close="onModalClose"
    @create="createItem"
  >
    <template
      v-if="pageName === 'templates'"
      #title
    >
      Create a Job Post Template
    </template>

    <template
      v-else
      #title
    >
      Create a {{ displayPageName }}
    </template>

    <template #info>
      <div
        v-if="pageName === 'templates'"
        class="mb-4"
      >
        Create a structured, reusable template to ensure consistency across job posts
      </div>
    </template>
  </CreateModal>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useSettingsTemplates } from '@/stores/settings/templatesForm';
import { useAppLoading } from '@/stores/app/loading';
import CreateModal from './CreateModal.vue';

const props = defineProps({
  pageName: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});

// Router
const router = useRouter();
const route = useRoute();
const { params } = route;

// Stores
const modalsStore = useModals();
const { setModal } = modalsStore;
const { show } = storeToRefs(modalsStore);

const { setLoading } = useAppLoading();

const { setShowBaseListLoader } = useSettingsTemplates();

// Computed
const displayPageName = computed(() => ({
  templates: 'Template',
}[props.pageName] || ''));

// Methods
const createItem = async (data) => {
  setModal({ field: 'settings', value: false });
  setShowBaseListLoader(true);
  setLoading({ listLoading: true });

  const createMethods = {
    templates: 'createNewTemplate',
  }[route.name];

  const { success, jobId: id } = await useSettingsTemplates()[createMethods](data);

  setLoading({ listLoading: false });

  if (success) {
    await router.push({ name: 'editor-view', params: { id } });
    setShowBaseListLoader(false);
  }
};

const onModalClose = () => {
  setModal({ field: 'settings', value: false });

  const id = params.from; // TODO check if this is in use

  if (id) {
    router.replace({ name: 'editor-view', params: { id } });
  }
};
</script>

<style scoped lang="less">
.modal-button {
  color: @text-darkest;

  &.v-btn--disabled {
    opacity: 0.6;

    :deep(.v-btn__overlay) {
      display: none;
    }
  }
}
</style>
